// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__3OZF2","dragIcon":"SortableItem_dragIcon__2Ue7z","disabled":"SortableItem_disabled__1rkNv"};